import { IndividualStatus, PayCalendarSalaryAllowance } from '@aslanpay/portal-common-lib';

export enum Role {
  SYSTEM_USER = 'System user',
  ASLAN_ADMIN = 'Aslan admin',
  COMPANY_ADMIN = 'Company admin',
  EMPLOYEE = 'Employee',
}

export enum PauseReason {
  MATERNITY_LEAVE = 'Maternity/Paternity leave',
  EXTENDED_SICK_LEAVE = 'Extended sick leave',
  FRAUD = 'Fraud',
  HR_REASONS = 'HR reasons',
  PROBATION = 'Probation',
}

export const Status: Record<IndividualStatus, { color: string; value: string; tooltip: string }> = {
  CREATED: {
    color: 'created',
    value: 'Created',
    tooltip: 'Imported into the database but not invited to sign-up',
  },
  INVITED: {
    color: 'invited',
    value: 'Invited',
    tooltip: 'Invited but has not signed up',
  },
  ACTIVE: {
    color: 'active',
    value: 'Active',
    tooltip: 'Confirmed and using the application',
  },
  DELETED: {
    color: 'deleted',
    value: 'Deleted',
    tooltip: 'Employee was deleted',
  },
  PAUSED: {
    color: 'paused',
    value: 'Paused',
    tooltip: 'Employee access to card is paused',
  },
  LEAVING: {
    color: 'leaving',
    value: 'Leaving',
    tooltip: 'Employee is leaving',
  },
  LEFT: {
    color: 'left',
    value: 'Left',
    tooltip: 'Employment terminated',
  },
  RESTRICTED: {
    color: 'restricted',
    value: 'Restricted',
    tooltip: 'Employee access to card is restricted',
  },
};

export const odpAllowancePercentageValues: PayCalendarSalaryAllowance[] = [
  5, 10, 15, 17, 20, 25, 30, 35, 40, 45, 50,
];

export const globalAllowancePercentageValues: PayCalendarSalaryAllowance[] = [
  5, 10, 15, 17, 20, 25, 30, 35, 40, 45, 50,
];

// Helper function to create dropdown options with custom option
export const createAllowancePercentageOptions = () => {
  const options = odpAllowancePercentageValues.map((value) => ({
    value: value.toString(),
    text: `${value}%`,
  }));

  // Add custom option
  options.push({
    value: 'CUSTOM',
    text: 'Custom %',
  });

  return options;
};
